import { render, staticRenderFns } from "./RulebookCyclesTab.vue?vue&type=template&id=22037e9e&scoped=true&"
import script from "./RulebookCyclesTab.vue?vue&type=script&lang=js&"
export * from "./RulebookCyclesTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookCyclesTab.vue?vue&type=style&index=0&id=22037e9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22037e9e",
  null
  
)

export default component.exports